var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefundSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2647_3752)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1107 2.93297C25.2253 4.57554 27.2114 5.40521 29.1641 5.02809C32.6085 4.35765 35.6422 7.39138 34.9718 10.8358C34.5946 12.7884 35.4159 14.7746 37.0669 15.8892C39.9749 17.8586 39.9749 22.141 37.0669 24.1104C35.4243 25.225 34.5946 27.2112 34.9718 29.1639C35.6422 32.6082 32.6085 35.642 29.1641 34.9715C27.2114 34.5944 25.2253 35.4157 24.1107 37.0666C22.1413 39.9747 17.8588 39.9747 15.8894 37.0666C14.7748 35.4241 12.7887 34.5944 10.836 34.9715C7.39163 35.642 4.3579 32.6082 5.02833 29.1639C5.40546 27.2112 4.58417 25.225 2.93322 24.1104C0.0251911 22.141 0.0251911 17.8586 2.93322 15.8892C4.57579 14.7746 5.40546 12.7884 5.02833 10.8358C4.3579 7.39138 7.39163 4.35765 10.836 5.02809C12.7887 5.40521 14.7748 4.58392 15.8894 2.93297C17.8588 0.024947 22.1413 0.024947 24.1107 2.93297Z",
    fill: "white",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2458 20.0036C39.2458 21.5708 38.5251 23.1296 37.0669 24.1101C35.6841 25.0487 34.8796 26.5907 34.8796 28.2165C34.8796 28.535 34.9131 28.845 34.9717 29.1635C35.0388 29.4903 35.0639 29.8088 35.0639 30.1273C35.0639 33.1526 32.2816 35.5829 29.1557 34.9795C28.854 34.9209 28.5355 34.8874 28.2338 34.8874C30.3206 34.3175 31.871 32.39 31.871 30.1273C31.871 29.8172 31.8458 29.4903 31.7788 29.1635C31.7201 28.8534 31.6866 28.535 31.6866 28.2249C31.6866 26.5991 32.4911 25.0487 33.8739 24.1101C35.3237 23.1296 36.0528 21.5708 36.0528 20.0036C36.0528 18.4365 35.3237 16.8777 33.8739 15.8972C32.4911 14.9586 31.6866 13.4082 31.6866 11.7824C31.6866 11.4723 31.7201 11.1539 31.7788 10.8438C32.2984 8.17879 30.6139 5.76521 28.2255 5.11992C28.5272 5.11992 28.8456 5.0864 29.1557 5.02773C29.4825 4.96907 29.801 4.93555 30.1111 4.93555C33.1448 4.93555 35.5835 7.71786 34.9717 10.8438C34.9131 11.1622 34.8796 11.4723 34.8796 11.7908C34.8796 13.4166 35.6841 14.9586 37.0669 15.8972C38.5251 16.8777 39.2458 18.4365 39.2458 20.0036Z",
    fill: "#D1D5DB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8343 13.166L13.1658 26.8346",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.638 17.7919C16.8275 17.7919 17.7918 16.8277 17.7918 15.6382C17.7918 14.4487 16.8275 13.4844 15.638 13.4844C14.4485 13.4844 13.4843 14.4487 13.4843 15.6382C13.4843 16.8277 14.4485 17.7919 15.638 17.7919Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.362 26.5156C25.5515 26.5156 26.5158 25.5513 26.5158 24.3618C26.5158 23.1723 25.5515 22.208 24.362 22.208C23.1725 22.208 22.2083 23.1723 22.2083 24.3618C22.2083 25.5513 23.1725 26.5156 24.362 26.5156Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2647_3752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefundSale);
export default __webpack_public_path__ + "static/media/icon_refund_sale.de2dd3f01e04f7955a34de8cdddc179a.svg";
export { ForwardRef as ReactComponent };